import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Calendar from '@components/calendar';
import { TRootState } from '@store/root-reducer';
import userInterfaceStore, { actions } from '@store/user-interface';
import TimeSlots from '@components/time-slots';

import AppointmentDateSC from './appointment-date.styled';
import StepButtons from '@components/step-buttons';

const AppointmentDate: React.FC = () => {
  const dispatch = useDispatch();

  const order = useSelector((store: TRootState) => store.userInterface.order);

  const {
    expert: { name: expertName },
  } = order;

  useEffect(() => {
    order.eventId && dispatch(userInterfaceStore.moveToNextStep());
  }, [dispatch, order]);

  const timeSlotRef = useRef<HTMLDivElement>(null);
  const datetime = useSelector(
    (store: TRootState) => store.userInterface.order.datetime,
  );
  const dayClicked = useSelector(
    (store: TRootState) => store.userInterface.dayClicked,
  );

  useEffect(() => {
    if (dayClicked && timeSlotRef.current) {
      timeSlotRef.current.scrollIntoView({ behavior: 'smooth' });
      dispatch(actions.setDayClicked(false));
    }
  }, [datetime, dayClicked, timeSlotRef, dispatch]);

  return (
    <AppointmentDateSC>
      <div className={'header'}>
        <h4>Vyberte e-termín</h4>
        <span>{expertName}</span>
      </div>
      <div className={'content'}>
        <Calendar />
        <TimeSlots ref={timeSlotRef} />
      </div>
      <div className={'footer'}>
        <StepButtons />
      </div>
    </AppointmentDateSC>
  );
};

export default AppointmentDate;
